import { PICS } from "./images";
import "./ColorChart.css";

const ColorChart = ({ pattern, elementName }) => {
  const headKey = pattern.elements.some((element) =>
    Object.keys(element).includes("newColor")
  );

  return (
    <div className="chartTable">
      <table>
        <thead>
          <tr>
            <th className="heading">Part</th>

            <th className="heading">Original</th>

            {headKey && <th className="heading">New</th>}
          </tr>
        </thead>
        <tbody>
          {pattern.elements.map((element, idx) => {
            return (
              <tr key={idx}>
                <td
                  className={
                    element.part === elementName ? "selectedPart" : "part"
                  }
                >
                  {element.part}
                </td>
                <td>
                  <div className="innerTD">
                    <img
                      alt="swatch"
                      src={
                        PICS.filter((pic) => pic.id === element.yarnCode)[0].url
                      }
                      className="colorCell"
                    />
                    {/* <div
                      className="colorCell"
                      style={{
                        backgroundColor: element.color,
                      }}
                    > 

                    </div> */}
                    <p className="codeText">{element.yarnCode}</p>
                  </div>
                </td>
                <td>
                  <div className="innerTD">
                    {element.newColor ? (
                      <img
                        alt="selected swatch"
                        src={
                          PICS.filter((pic) => pic.id === element.newCode)[0]
                            .url
                        }
                        className="colorCell"
                      />
                    ) : null}
                    {/* <div
                        className="colorCell"
                        style={{
                          backgroundColor: element.newColor,
                        }}
                      >
                      </div> */}
                    <p className="codeText">
                      {element.newColor ? element.newCode : null}
                    </p>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {elementName && (
        <div className="selectTextContainer">
          <p className="selectText">Select a new color for the&nbsp;</p>
          <span className="selectedPart">{elementName}</span>
        </div>
      )}
    </div>
  );
};

export default ColorChart;

// <div className="elementChart">
//         <div className="elementList">
//           <p>{element.part}</p>
//         </div>
//         <div className="elementList">
//           <div
//             style={{
//               backgroundColor: element.color,
//               height: "20px",
//               width: "20px",
//             }}
//           ></div>
//           <p>{element.yarnCode}</p>
//         </div>
//         <div className="elementList">
//           <div
//             style={{
//               backgroundColor: element.newColor,
//               height: "20px",
//               width: "20px",
//             }}
//           ></div>
//           <p>{element.newCode}</p>
//         </div>
//       </div>
